import { RootState } from "../../../../../redux/store";
import * as constants from "./constants";

export const isItemsLoading = (state:RootState) => state.countries.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.countries.actionsLoading;
export const getItems = (state:RootState) => state.countries.items;
export const getItemsSelect = (state:RootState) => state.countries.dropDownItems;
export const getItemsCount = (state:RootState) => state.countries.itemsCount;
export const getItemForEdit = (state:RootState) => state.countries.itemForEdit;
export const getError = (state:RootState) => state.countries.error;
export const getErrorAction = (state:RootState) => state.countries.errorAction;
export const validationErrors = (state: RootState) => state.countries.validationErrors;